import { useState, useRef, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Transition } from "@headlessui/react"
import { Tooltip } from "flowbite-react"
import style  from "react"

import { IconosMenu } from './IconosMenu.js'


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


const Tab = ({ x, activeTab, recibirId, top, id, setAncho }) => {
    const [show, setShow] = useState(false);
    const location = useLocation()
    const navigate = useNavigate()
    
const verRuta = ( ruta ) => {
        if (ruta[0].href === "/campus/reporte_morosidad"){
            
            console.log('ES')
            console.log(location)
            location.pathname="/campus/reporte_descuento_reducido"
            location.search="/campus/reporte_morosidad"

            //history.replace()
            //window.location.pathname="/campus/reporte_descuento_reducido"
        }

}

    if (x.access) {

        if (x.name !== activeTab) {
            x.current = false
        } else {
            x.current = true
        }

        return (
            <div className='   relative |inline |flex |inline |inline-flex'
            onMouseOut={() => {setShow(false);!x.subMenu&&setAncho("4")}}
            >{/* menu contenedor */}

                <Tooltip content={x.name} placement={x.subMenu ? 'top-start' : 'right'} animation='duration-1000'>
                    <Link
                    key={x.name}
                        onMouseOver={x.subMenu ? () => {setShow(()=>true);setAncho(()=>"110");setAncho(()=>"110");} : () => {setShow(()=>false);setAncho(()=>"110")}}
                        onMouseOut={x.subMenu ? () => {setShow(()=>false);setAncho(()=>"4")} : () => {setShow(()=>false);setAncho(()=>"4")}}
                        //onClick={() => {setShow(current => !!current);change?window.location.reload(): console.log("111");setTab(()=> x.name)}} // si el tab es diferente al actual, que lo cambie
                        onClick={() => {setShow(current => !!current);show?window.location.reload(): 
                            console.log(x)
                            if(window.innerWidth>1500 && (window.location.pathname === x.href)){
                                window.location.reload()
                            }
                            // si la pantalla e grande, refresh
                        }}
                        to={x.href}
                        className={classNames(
                            x.current ? 'bg-gray-900 text-white' : 'text-gray-400 hover:bg-gray-700',
                            'flex-shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg'
                        )}
                    >
                        <IconosMenu
                            classes='h-6 w-6'
                            nameIcono={x.icon} />
                    </Link>
                </Tooltip>

                {
                    x.subMenu ?
                        <Transition
                            show={show}
                            >
                            <div 
                            onMouseOver={() => {x.subMenu && setShow(true);setAncho(()=>"110");}} //false
                            onMouseOut={() => {x.subMenu && setShow(false);setAncho(()=>"4");}} //false
                            onClick={()=>verRuta(x.subMenu)}
                            className={` bg-primarioMira  rounded-lg w-96 p-3  |-mt-4 |-ml-4 -top-1 left-14 absolute  |relative |g `}
                            >
                                <style>
                                    {
                                        `.g{
                                            width: auto;
                                            position: fixed;
                                        }`
                                    }
                                </style>
                            {/* aqui se debe obtener y setear la posicion */}
                            
                                {x.subMenu.map((y) => {
                                        
                                        //Función para activar solo pestaña requerida por la prop activeTab
                                        if (y.access) {
                                            if (y.name !== activeTab) {
                                                y.current = false
                                        } else {
                                            y.current = true
                                        }
                                        return (
                                            <Link
                                                key={y.name}
                                                onMouseOver={() => {setShow(()=>true);}}
                                                onMouseOut={() => {setAncho(()=>"4")}}
                                                //onMouseOut={x.subMenu ? () => {setShow(()=>false);setAncho(()=>"4")} : () => {setShow(()=>false);setAncho(()=>"4")}}
                                                
                                                to={y.href}
                                                className={classNames(
                                                    y.current
                                                    ? 'bg-gray-900 text-white'
                                                    : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                    'pl-8 flex items-center px-2 py-2 text-base font-medium rounded-md  '
                                                    )}
                                                    >
                                                    <IconosMenu
                                                    nameIcono={y.icon}
                                                    onMouseOut={() => {setAncho(()=>"4")}}
                                                    //onMouseOut={x.subMenu ? () => {setShow(()=>false);setAncho(()=>"4")} : () => {setShow(()=>false);setAncho(()=>"4")}}
                                                    classes={y.current
                                                        ? 'text-gray-300 mr-4 flex-shrink-0 h-6 w-6'
                                                        : 'text-gray-400 group-hover:text-gray-300 mr-4 flex-shrink-0 h-6 w-6'}
                                                        />
                                                        {y.name}

                                                        
                                                        </Link>
                                                        )
                                                        
                                                    } else {
                                                        return null
                                                    }
                                                
                                                    
                                                })}
                            </div>
                            </Transition>
                        : null
                }
            </div>
        )
    } else {
        return null
    }
}

export default Tab